module.exports = __webpack_public_path__ + "images/screenshot4.jpg";